import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Problem from "@/components/landing/Problem";
import BeforeAfter from "@/components/landing/BeforeAfter";
import Solution from "@/components/landing/Solution";
import ExampleInteraction from "@/components/landing/ExampleInteraction";
import HowItWorks from "@/components/landing/HowItWorks";
import Accessibility from "@/components/landing/Accessibility";
import Vision from "@/components/landing/Vision";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import CookieBanner from "@/components/landing/CookieBanner";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";

const Home = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Problem />
      <BeforeAfter />
      <Solution />
      <ExampleInteraction />
      <HowItWorks />
      <Accessibility />
      <Vision />
      <FinalCTA />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App relative" data-testid="equallayer-app">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0A0A0A",
            border: "1px solid rgba(99,102,241,0.35)",
            color: "#fff",
          },
        }}
      />
    </div>
  );
}

export default App;
